import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { withRouter } from '@/checkout-instore-legacy/utils/withRouter'
import { injectIntl, FormattedMessage } from 'react-intl'
import Input from '@vtex/styleguide/lib/Input'
import Button from '@vtex/styleguide/lib/Button'
import { getCountryCode } from '@/checkout-instore-legacy/utils/orderFormUtils'

import { intlShape } from '@/checkout-instore-legacy/i18n/intlShape'
import { ROUTES } from '@/checkout-instore-legacy/constants/RoutesConstants'
import SummaryView from '@/checkout-instore-legacy/components/Commons/Summary/containers/SummaryViewContainer'
import withOrderFormAndVendor from '@/checkout-instore-legacy/order/withOrderFormAndVendor'
import AvailableAddresses from '@/checkout-instore-legacy/shipping/components/AvailableAddresses'
import {
  validateZipCode,
  maskPostalCode,
  handleCEPInputMask,
} from '@/checkout-instore-legacy/shipping/utils'
import withOrderFormNotEmpty from '@/checkout-instore-legacy/order/withOrderFormNotEmpty'
import { isClientComplete } from '@/checkout-instore-legacy/customer/utils'

class PostalCode extends Component {
  constructor(props) {
    super(props)

    const {
      shipping: { address },
      orderForm,
    } = props
    const postalCode = address && address.postalCode

    const countryCode = getCountryCode(orderForm)

    this.state = {
      countryCode,
      postalCode: maskPostalCode(postalCode) || '',
      isPostalCodeValid: validateZipCode(postalCode, countryCode),
      loading: false,
    }
  }

  handlePostalCodeValidation = () => {
    const { postalCode } = this.state

    this.setState({
      isPostalCodeValid: validateZipCode(postalCode, this.state.countryCode),
    })
  }

  handleChange = (e) => {
    const postalCode = e.target.value
    const maskedPostalCode = maskPostalCode(postalCode)

    this.setState({
      postalCode: maskedPostalCode,
      isPostalCodeValid: validateZipCode(postalCode, this.state.countryCode),
    })
  }

  handleSubmit = (e) => {
    e.preventDefault()

    const { postalCode, countryCode } = this.state
    const { setShippingWasFilled } = this.props

    if (validateZipCode(postalCode, this.state.countryCode)) {
      this.setState({ loading: true })
      setShippingWasFilled()
      this.props.sendPostalCode(postalCode, countryCode)
    }
  }

  handleFocus = (e) => {
    const element = e.target
    // Wait keyboard to open
    setTimeout(() => {
      element.scrollIntoView()
    }, 200)
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.postalCodeInput) {
      handleCEPInputMask(
        prevState.postalCode,
        this.state.postalCode,
        this.postalCodeInput
      )
    }
  }

  componentDidMount() {
    const { orderForm } = this.props
    const customer = orderForm.clientProfileData

    if (!isClientComplete(customer)) {
      this.props.router.push(ROUTES.CLIENT_REGISTER)
    }
  }

  render() {
    const { postalCode, isPostalCodeValid, loading } = this.state
    const {
      shipping: { availableAddresses, selectedAddresses },
      router,
      intl,
      sendAddressOnShippingData,
      isOnline,
      setShippingWasFilled,
    } = this.props
    return (
      <SummaryView>
        <form
          className="flex flex-auto flex-column overflow-auto momentum"
          onSubmit={this.handleSubmit}
        >
          <AvailableAddresses
            router={router}
            selectAddress={sendAddressOnShippingData}
            availableAddresses={availableAddresses}
            selectedAddresses={selectedAddresses}
            setShippingWasFilled={setShippingWasFilled}
          />
          <div className="flex flex-column pt7">
            <div className="form-horizontal text-center pa5 pt0-l mh7-ns mh5">
              <div className="w-100 w-80-ns w-30-l mb4 mb5-ns tc center">
                <Input
                  id="postalCode"
                  type="text"
                  label={intl.formatMessage({
                    id: 'shippingPostalCodeLabel',
                  })}
                  value={postalCode}
                  autoFocus={!postalCode && availableAddresses.length === 0}
                  onFocus={this.handleFocus}
                  onChange={this.handleChange}
                  onBlur={this.handlePostalCodeValidation}
                  className={`${
                    isPostalCodeValid || !postalCode ? '' : 'b--red'
                  }`}
                  ref={(postalCodeInput) =>
                    (this.postalCodeInput = postalCodeInput)
                  }
                  size="large"
                  autoComplete="off"
                  autoCorrect="off"
                  autoCapitalize="off"
                  spellCheck="false"
                />
              </div>
              <div className="w-100 w-30-l w-80-ns mt4 mt5-ns center">
                <Button
                  id="postalCodeConfirm"
                  type="submit"
                  disabled={!isPostalCodeValid || !isOnline}
                  isLoading={loading}
                  variation="primary"
                  size="large"
                  block
                >
                  <FormattedMessage id="shippingPostalConfirmButton" />
                </Button>
              </div>
            </div>
          </div>
        </form>
      </SummaryView>
    )
  }
}

PostalCode.propTypes = {
  sendPostalCode: PropTypes.func,
  sendAddressOnShippingData: PropTypes.func,
  saveShippingData: PropTypes.func,
  shipping: PropTypes.any,
  router: PropTypes.any,
  intl: intlShape.isRequired,
  orderForm: PropTypes.object.isRequired,
  isOnline: PropTypes.bool,
  setShippingWasFilled: PropTypes.func,
}

PostalCode.defaultProps = {
  isOnline: true,
}

export default injectIntl(
  withRouter(withOrderFormAndVendor(withOrderFormNotEmpty(PostalCode)))
)
